<template>
    <b-form @submit.prevent="getHash" class="hidden-album-form">
        <div v-if="label" :class="['helper','helper--hidden-album', `helper--hidden-album--${position}`]">{{ $t('type_password_here') }}</div>
        <b-input-group>
            <b-form-input v-model="privateKey" id="hidden-album-input"
                          :style="`${borderRadius ? `border-radius: ${+borderRadius > 0 ? `${borderRadius}px` : '0'}` : ''}`"
                          :placeholder="$t('personal_password')" autocomplete="off"></b-form-input>
            <b-button type="submit" :class="['btn', {'btn-disabled': privateKey === ''}]"
                      :style="`${borderRadius ? `border-radius: ${+borderRadius > 0 ? `${borderRadius}px` : '0'}` : ''}`">
                <span class="material-icon icon-lock_open"></span>
            </b-button>
        </b-input-group>
    </b-form>
</template>

<style>
    .hidden-album-form .btn-disabled .material-icon {
        opacity: .5;
    }
</style>

<style lang="scss" scoped>
    @import "../scss/variables";

    .hidden-album {

        &-form {
            position: relative;
        }
    }

    .input-group {

        .form-control,
        .btn {
            border-radius: $border-radius;
        }

        .form-control {
            border-right: none;

            &:focus + .btn {
                border-color: darken($border-color, 15%) !important;
            }
        }

        .btn {
            padding: 0 1rem;
            border-left: none;
            border-color: $border-color !important;
            color: var(--text-color);
            background-color: var(--bg-color) !important;
        }
    }
</style>

<script>
  import hiddenAlbumForm from 'src/mixins/hiddenAlbumFormComponent';

  export default {
    mixins: [hiddenAlbumForm],
  };
</script>
